import Header from "../../components/header";
import DialogBox from "../../components/dialogBox";
import React, { useEffect, useState, Fragment } from "react";
import Select from "react-select";
import InputMaps from "../../components/InputMaps";
import Inputs from "../../components/inputs";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import { Row, Col, Toggle, Uploader, Input, DateRangePicker } from "rsuite";
import DrawerComponent from "../../components/drawer";
import UserForm from "./userForm";
import PopupComponent from "../../components/PopupComponent";
import PhoneInput from "react-phone-input-2";
import InputStyledComp from "../../components/webForm/InputStyledComp";
import MultipleOption from "../../components/webForm/MultipleOption";
import toast, { Toaster } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUpload } from "@fortawesome/free-solid-svg-icons";
import { Trash2 } from "lucide-react";
import {
  createCustomForm,
  editCustomForm,
  formLeadList,
  getFormList,
  getFormListById,
  uploadFile,
} from "../../services/formService";
import ConfirmationModal from "../../components/confirmationModal";
import moment from "moment";
import { useSelector } from "react-redux";
import PaymentFiels from "../../components/webForm/PaymentFiels";
import DynamicConfirmationModal from "../../components/DynamicConfirmationModal";
import styled from "styled-components";
import { Logger } from '../../utils/logger';
import { migrateGroupFieldNames, needsMigration, getMigrationSummary } from '../../utils/groupFieldMigration';
import "./userForm.css";
interface FormData {
  name: string;
  listId: string;
  description: string;
  form: any[];
  createdAt: any;
  createdBy: string;
  // _id:string;
  // type: string;
  // uniqueCode: string;
  // listName: string;
}

interface UserListProps {
  onCreateNew?: () => void;
  onEditForm?: (formId: string) => void;
  onViewResponses?: (formId: string) => void;
}

const UserList: React.FC<UserListProps> = ({ 
  onCreateNew, 
  onEditForm, 
  onViewResponses 
}) => {
  const initialFormData: FormData = {
    // _id:'',
    name: "",
    description: "",
    listId: "",
    createdAt: "",
    createdBy: "",
    form: [],
    // uniqueCode:''
  };

  const [formOpen, setFormOpen] = useState(false);
  const [fullScreenForm, setFullScreenForm] = useState(false);
  const [questionBox, setQuestionBox] = useState(false);

  const [activeField, setActiveField] = useState("");
  const [openWithHeader, setOpenWithHeader] = useState<boolean>(false);
  const [showFullPageForm, setShowFullPageForm] = useState<boolean>(false);
  const [fieldModal, setFieldModal] = useState<boolean>(false);
  const [isPageLoad, setIsPageLoad] = useState<boolean>(false);
  const [formCloseModel, setFormCloseModel] = useState<boolean>(false);
  const [stepFormModel, setStepFormModel] = useState<boolean>(false);
  const [userList, setUserList] = useState<any>([]);
  const [activeQuestion, setActiveQuestion] = useState<any>("");
  const [activeFormId, setActiveFormId] = useState<string>("");
  const [totalUser, setTotalUser] = useState(0);
  const [userType, setUserType] = useState<string>("Create");
  const [userName, setUserName] = useState("");
  const [updateFormData, setUpdateFormData] = useState<FormData>({
    name: "",
    description: "",
    listId: "",
    form: [],
    createdAt: "",
    createdBy: "",
  });
  const [newFormData, setNewFormData] = useState<any>({
    name: "",
    formType: "lead",
    list: "",
    description: "",
    form: [],
  });

  const [leadList, setLeadList] = useState([]);
  const [activeOption, setActiveOption] = useState("");
  const [nestedFieldModal, setNestedFieldModal] = useState<boolean>(false);
  const [activeGroupQuestion, setActiveGroupQuestion] = useState<string>("");

  const { id } = useParams();

  const StoreData = useSelector((state: any) => {
    return state?.rootReducers;
  });

  const handleCreateForm = async () => {
    // validations
    if (newFormData.name.length < 3) {
      return toast.error("Please Enter Form Name");
    }
    // else if (newFormData.description.length < 10) {
    //     return toast.error("Please Enter Descripton");
    // }
    setUserType("Create");
    setFormOpen(false);
    setFullScreenForm(true);
  };

  const updateCreateForm = (type: string, value: any) => {
    const data = { ...newFormData, [type]: value };
    setNewFormData(data);
    // setUpdateFormData(data)
  };

  const handleClickUser = async (id: string) => {
    setIsPageLoad(true);
    try {
      const response = await getFormListById(id);
      setIsPageLoad(false);
      if (response && response.status) {
        setShowFullPageForm(true); // Show full page instead of drawer
        setActiveFormId(id);
        setUserType("Update");
        setUpdateFormData(response.data.data);
      }
    } catch (err) {
      setIsPageLoad(false);
      Logger.log(err, "Error");
    }
  };
  const handleFormList = async () => {
    try {
      setIsPageLoad(true);
      const response = await getFormList();
      setIsPageLoad(false);
      if (response && response.status) {
        setUserList(response.data.data.reverse());
        setTotalUser(response.data.total);
      }
    } catch (err) {
      setIsPageLoad(false);
      Logger.log(err, "Error");
    }
  };

  const handleAddQuestionToGroup = (fieldType: string) => {
    // This function adds a question to a group field instead of the main form
    const fieldTemplates: any = {
      short_text: {
        fieldName: "Short text",
        displayName: "Short text",
        type: "short_text",
        placeholder: "Enter text",
        description: "",
        required: false,
      },
      name: {
        fieldName: "Name",
        displayName: "Name",
        type: "short_text",
        placeholder: "Enter name",
        description: "",
        required: false,
      },
      email: {
        fieldName: "Email",
        displayName: "Email",
        type: "email",
        placeholder: "Enter email",
        description: "",
        required: false,
      },
      phone: {
        fieldName: "Phone",
        displayName: "Phone",
        type: "phone",
        placeholder: "Enter phone",
        description: "",
        required: false,
      },
      number: {
        fieldName: "Number",
        displayName: "Number",
        type: "number",
        placeholder: "Enter number",
        description: "",
        required: false,
      },
      date: {
        fieldName: "Date",
        displayName: "Date",
        type: "date",
        placeholder: "Select date",
        description: "",
        required: false,
      },
      long_text: {
        fieldName: "Long text",
        displayName: "Long text",
        type: "long_text",
        placeholder: "Enter text",
        description: "",
        required: false,
      },
      file_upload: {
        fieldName: "File upload",
        displayName: "File upload",
        type: "file_upload",
        placeholder: "Upload file",
        description: "",
        required: false,
      },
      address: {
        fieldName: "Address",
        displayName: "Address",
        type: "address",
        placeholder: "Enter address",
        description: "",
        required: false,
      },
      multiple_options: {
        fieldName: "Multiple Option",
        displayName: "Multiple Option",
        type: "multiple_options",
        placeholder: "Select option",
        description: "",
        required: false,
        multipleSelection: false,
        options: [{ displayName: "Option_1", value: "" }],
      },
    };

    const newField = fieldTemplates[fieldType];
    if (!newField) return;

    addNestedFieldToGroup(activeGroupQuestion, fieldType);
    setActiveGroupQuestion("");
    setQuestionBox(false);
  };

  const handleAddQuestion = (value: string) => {
    // If adding to a group, use special handler
    if (activeGroupQuestion) {
      handleAddQuestionToGroup(value);
      return;
    }

    let count = 0;
    if (userType == "Create") {
      newFormData.form.forEach((formItem: any) => {
        formItem.fields.forEach((field: any) => {
          if (field.type === value) {
            count++;
          }
        });
      });
    } else {
      updateFormData.form.forEach((formItem: any) => {
        formItem.fields.forEach((field: any) => {
          if (field.type === value) {
            count++;
          }
        });
      });
    }

    // Logger.log('count ====> name',count)
    setQuestionBox(false);
    if (value == "short_text") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Short text ${count == 0 ? "" : count}`,
            displayName: `Short text ${count == 0 ? "" : count}`,
            type: "short_text",
            placeholder: "Enter Text",
            description: "",
            required: false,
            validations: [
              {
                min: 4,
                message: "Name should be greater than 4 character",
              },
              {
                max: 20,
                message: "Name should be less than 20 characters",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "name") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Name ${count == 0 ? "" : count}`,
            displayName: `Name ${count == 0 ? "" : count}`,
            type: "short_text",
            placeholder: "Enter Text",
            description: "",
            required: false,
            validations: [
              {
                min: 4,
                message: "Name should be greater than 4 character",
              },
              {
                max: 20,
                message: "Name should be less than 20 characters",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "phone") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: "phone",
            displayName: `Phone ${count == 0 ? "" : count}`,
            type: "phone",
            placeholder: "Enter phone number",
            description: "",
            required: false,
            validations: [
              {
                min: 7,
                message: "Phone should be greater than 7",
              },
              {
                max: 10,
                message: "Phone should be less than 10",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "file_upload") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `File Upload ${count == 0 ? "" : count}`,
            displayName: `File Upload ${count == 0 ? "" : count}`,
            type: "file_upload",
            placeholder: "Upload file ",
            description: "",
            required: false,
            validations: [
              {
                min: 100,
                message: "file size less then 100 mb each",
              },
              {
                max: 100,
                message: "file size less then 100 mb each",
              },
            ],
          },
        ],
      };

      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "email") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: "email",
            displayName: `Email ${count == 0 ? "" : count}`,
            type: "email",
            placeholder: "Enter valid email",
            description: "",
            required: false,
            validations: [
              {
                message: "valdi email with @ and . symbol",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "long_text") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Long Text ${count == 0 ? "" : count}`,
            displayName: `Long Text ${count == 0 ? "" : count}`,
            type: "long_text",
            placeholder: "Enter Text",
            description: "",
            required: false,
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "number") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Number ${count == 0 ? "" : count}`,
            displayName: `Number ${count == 0 ? "" : count}`,
            type: "number",
            placeholder: "Enter number",
            description: "",
            required: false,
            validations: [
              {
                min: 4,
                message: "Name should be greater than 4 character",
              },
              {
                max: 20,
                message: "Name should be less than 20 characters",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "date") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Date ${count == 0 ? "" : count}`,
            displayName: `Date ${count == 0 ? "" : count}`,
            type: "date",
            placeholder: "Select Date",
            description: "",
            required: false,
            validations: [
              {
                min: "2023-12-20T00:00:00.000Z",
                message: "Date must be after December 20, 2023",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "address") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Enter Address ${count == 0 ? "" : count}`,
            displayName: `Enter Address ${count == 0 ? "" : count}`,
            type: "address",
            placeholder: "Enter Address",
            description: "",
            required: false,
            validations: [
              {
                min: 10,
                message: "Address should be at least 10 characters",
              },
              {
                max: 500,
                message: "Address should be less than 500 characters",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "multiple_options") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Multiple Option ${count == 0 ? "" : count}`,
            displayName: `Multiple Option ${count == 0 ? "" : count}`,
            type: "multiple_options",
            placeholder: "Select option",
            description: "",
            required: false,
            multipleSelection: false,
            options: [
              {
                displayName: "Option_1",
                value: "",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "end_screen") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: "end_screen",
            displayName: "End Screen",
            type: "end_screen",
            description: "",
            placeholder: "Enter message",
            required: false,
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "payment") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: "Payment Amount",
            displayName: "Payment Amount",
            type: "payment",
            placeholder: "00.00",
            amount: "",
            description: "",
            required: true,
            validations: [
              {
                min: 7,
                message: "Phone should be greater than 7",
              },
              {
                max: 10,
                message: "Phone should be less than 10",
              },
            ],
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "text_display") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Text Display ${count == 0 ? "" : count}`,
            displayName: `Text Display ${count == 0 ? "" : count}`,
            type: "text_display",
            placeholder: "Text Display",
            textContent: "Enter your text content here. You can use this to display terms and conditions, privacy policy, or any other information.",
            buttonText: "I Agree",
            description: "",
            required: false,
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    } else if (value == "group_field") {
      const data = {
        question: "step",
        conditionRule: [],
        fields: [
          {
            fieldName: `Group Field ${count == 0 ? "" : count}`,
            displayName: `Group Field ${count == 0 ? "" : count}`,
            type: "group_field",
            placeholder: "Group Field",
            description: "Group multiple fields together",
            groupFields: [], // Array to hold nested fields
            required: false,
          },
        ],
      };
      if (userType == "Create") {
        const updateData = {
          ...data,
          question: `question_${newFormData.form.length + 1}`,
        };
        const updatedFormData = {
          ...newFormData,
          form: [...newFormData.form, updateData],
        };
        setNewFormData(updatedFormData);
      } else {
        const updateData = {
          ...data,
          question: `question_${updateFormData.form.length + 1}`,
        };
        const updatedFormData: FormData = {
          ...updateFormData,
          form: [...updateFormData.form, updateData],
        };
        setUpdateFormData(updatedFormData);
      }
    }

    // If we're adding to a group, clear the context
    if (activeGroupQuestion) {
      setActiveGroupQuestion("");
    }

    setActiveField(`question_${newFormData.form.length + 1}`);
    setQuestionBox(false);
  };

  const onCreateNewForm = () => {
    setFormOpen(true);
    // const dummyObject = {
    //     _id:'',
    //     name: "",
    //     description: "",
    //     type: "lead",
    //     form:[],
    //     uniqueCode:''
    //     // createdBy: "Vivek",
    //     // listName: "Custom form",
    // }
    setUserType("Create");
    // setUpdateFormData(dummyObject)
  };

  // TEMPORARY: Migration handler for group field names - REMOVE BEFORE PRODUCTION
  const handleMigrateGroupFields = () => {
    try {
      const formToMigrate = userType === "Create" ? newFormData : updateFormData;

      // Check if migration is needed
      if (!needsMigration(formToMigrate)) {
        toast.success("Form already migrated! No changes needed.");
        Logger.log("Migration check: Form already up to date");
        return;
      }

      // Perform migration
      const { migratedForm, fieldNameMap, changeCount } = migrateGroupFieldNames(formToMigrate);

      // Show summary
      const summary = getMigrationSummary(migratedForm, fieldNameMap);
      Logger.log(summary);

      // Update the form data
      if (userType === "Create") {
        setNewFormData(migratedForm);
      } else {
        setUpdateFormData(migratedForm as FormData);
      }

      toast.success(`Successfully migrated ${changeCount} field(s)! Please save the form.`);
      Logger.log(`Migration completed: ${changeCount} fields updated`, fieldNameMap);
    } catch (error: any) {
      toast.error("Migration failed: " + error.message);
      Logger.log("Migration error:", error);
    }
  };

  const handleSubmitForm = async () => {
    try {
      setIsPageLoad(true);
      const endScreen = {
        question: "step",
        fields: [
          {
            fieldName: "end_screen",
            displayName: "End Screen",
            type: "end_screen",
            description:
              "Thank you for your response. We will be in touch shortly",
            placeholder: "Enter message",
            required: false,
          },
        ],
      };

      if (userType == "Create") {
        const updatedJson = { ...newFormData };
        updatedJson.form.forEach((step: any) => {
          step.fields.forEach((field: any) => {
            field.fieldName = field.fieldName.trim().replace(/ /g, "_");
          });
        });
        const selectOptionField = updatedJson.form.find((step: any) => {
          return step.fields.some(
            (field: any) => field.type === "multiple_options"
          );
        });

        if (selectOptionField) {
          const selectOption = selectOptionField.fields.find(
            (field: any) => field.type === "multiple_options"
          );
          if (selectOption && selectOption.options) {
            // Check for empty options before filtering
            const hasEmptyOptions = selectOption.options.some(
              (opt: any) => !opt.value || opt.value.trim() === ""
            );

            if (hasEmptyOptions) {
              toast.error("Please fill in all option values or remove empty options");
              setIsPageLoad(false);
              return;
            }

            selectOption.options.forEach((option: any) => {
              option.value = option.value.trim().replace(/ /g, "_");
            });
          }
          // if (selectOption && selectOption.options) {
          //   selectOption.options.forEach((option:any) => {
          //     option.value = option.value.trim().replace(/ /g, "_");
          //     option.displayName = option.displayName;
          //   });
          // }
        }

        const hasEndScreen = updatedJson.form.some((step: any) =>
          step.fields.some((field: any) => field.type === "end_screen")
        );
        const hasEmailNumber = updatedJson.form.some((step: any) =>
          step.fields.some((field: any) => {
            // Check if field itself is email or phone
            if (field.type === "email" || field.type === "phone") {
              return true;
            }
            // Check if it's a group field containing email or phone
            if (field.type === "group_field" && field.groupFields && Array.isArray(field.groupFields)) {
              return field.groupFields.some((nestedField: any) =>
                nestedField.type === "email" || nestedField.type === "phone"
              );
            }
            return false;
          })
        );

        if (!hasEmailNumber) {
          toast.error("Must Include at least one phone or email question");
          setIsPageLoad(false);
          return;
        }

        if (!hasEndScreen) {
          updatedJson.form.push({
            ...endScreen,
            question: `question_${updatedJson.form.length + 1}`,
          });
        }
        if (updatedJson.hasOwnProperty("list") && updatedJson.list === "") {
          delete updatedJson.list;
        }

        const response = await createCustomForm(updatedJson);
        if (response && response.status) {
          handleFormList();
          setFullScreenForm(false);
          setNewFormData({
            name: "",
            formType: "lead",
            list: "",
            description: "",
            form: [],
          });
          setFormOpen(false);
          toast.success("Form created successfully!");
        } else {
          toast.error(response?.data?.message || "Failed to create form. Please try again.");
        }
      } else {
        const updatedJson = { ...updateFormData };
        updatedJson.form.forEach((step: any) => {
          step.fields.forEach((field: any) => {
            field.fieldName = field.fieldName.trim().replace(/ /g, "_");
          });
        });
        const selectOptionField = updatedJson.form.find((step: any) => {
          return step.fields.some(
            (field: any) => field.type === "multiple_options"
          );
        });

        if (selectOptionField) {
          const selectOption = selectOptionField.fields.find(
            (field: any) => field.type === "multiple_options"
          );
          if (selectOption && selectOption.options) {
            selectOption.options.forEach((option: any) => {
              option.value = option.value.trim().replace(/ /g, "_");
              option.displayName = option.displayName;
            });
          }
        }
        const hasEndScreen = updatedJson.form.some((step) =>
          step.fields.some((field: any) => field.type === "end_screen")
        );
        const hasEmailNumber = updatedJson.form.some((step: any) =>
          step.fields.some((field: any) => {
            // Check if field itself is email or phone
            if (field.type === "email" || field.type === "phone") {
              return true;
            }
            // Check if it's a group field containing email or phone
            if (field.type === "group_field" && field.groupFields && Array.isArray(field.groupFields)) {
              return field.groupFields.some((nestedField: any) =>
                nestedField.type === "email" || nestedField.type === "phone"
              );
            }
            return false;
          })
        );

        if (!hasEmailNumber) {
          toast.error("Must Include at least one phone or email question");
          setIsPageLoad(false);
          return;
        }
        if (!hasEndScreen) {
          updatedJson.form.push({
            ...endScreen,
            question: `question_${updatedJson.form.length + 1}`,
          });
        }

        const response = await editCustomForm(
          updateFormData.form,
          activeFormId
        );
        if (response && response.status) {
          handleFormList();
          setFullScreenForm(false);
          setFormOpen(false);
          toast.success(response.data.message || "Form updated successfully!");
        } else {
          toast.error(response?.data?.message || "Failed to update form. Please try again.");
        }
      }
      setIsPageLoad(false);
    } catch (err) {
      setIsPageLoad(false);
      setFormOpen(false);
      Logger.log(err, "Error");
    }
  };

  const handleEditFormValue = (
    step: string,
    type: string,
    keyName: string,
    value: string | boolean
  ) => {
    if (userType == "Create") {
      if (type == "multiple_options") {
        // if(type == 'multiple_options' || type =='date'){
        const updatedForm = newFormData.form.map((item: any) => {
          if (item.question === step) {
            const updatedFields = item.fields.map((field: any) => {
              if (field.type === type) {
                if (keyName == "displayName") {
                  return {
                    ...field,
                    fieldName: value,
                    [keyName]: value, // Update the specified field with the new value
                  };
                } else {
                  return {
                    ...field,
                    [keyName]: value, // Update the specified field with the new value
                  };
                }
              }
              return field;
            });
            return {
              ...item,
              fields: updatedFields,
            };
          }
          return item;
        });
        const updatedFormData: FormData = {
          ...newFormData,
          form: updatedForm,
        };
        setNewFormData(updatedFormData);
      } else {
        const updatedForm = newFormData.form.map((item: any) => {
          if (item.question === step) {
            const updatedFields = item.fields.map((field: any) => {
              if (field.type === type) {
                if (keyName == "displayName") {
                  return {
                    ...field,
                    fieldName: value,
                    [keyName]: value, // Update the specified field with the new value
                  };
                } else {
                  return {
                    ...field,
                    [keyName]: value, // Update the specified field with the new value
                  };
                }
              }
              return field;
            });
            return {
              ...item,
              fields: updatedFields,
            };
          }
          return item;
        });
        const updatedFormData: FormData = {
          ...newFormData,
          form: updatedForm,
        };
        setNewFormData(updatedFormData);
      }
    } else {
      if (type == "multiple_options") {
        // if(type == 'multiple_options' || type =='date'){
        const updatedForm = updateFormData.form.map((item: any) => {
          if (item.question === step) {
            const updatedFields = item.fields.map((field: any) => {
              if (field.type === type) {
                if (keyName == "displayName") {
                  return {
                    ...field,
                    fieldName: value,
                    [keyName]: value, // Update the specified field with the new value
                  };
                } else {
                  return {
                    ...field,
                    [keyName]: value, // Update the specified field with the new value
                  };
                }
              }
              return field;
            });
            return {
              ...item,
              fields: updatedFields,
            };
          }
          return item;
        });
        const updatedFormData: FormData = {
          ...updateFormData,
          form: updatedForm,
        };
        setUpdateFormData(updatedFormData);
      } else {
        const updatedForm = updateFormData.form.map((item: any) => {
          if (item.question === step) {
            const updatedFields = item.fields.map((field: any) => {
              if (field.type === type) {
                if (keyName == "fieldName") {
                  return {
                    ...field,
                    placeholder: value,
                    [keyName]: value, // Update the specified field with the new value
                  };
                } else {
                  return {
                    ...field,
                    [keyName]: value, // Update the specified field with the new value
                  };
                }
              }
              return field;
            });
            return {
              ...item,
              fields: updatedFields,
            };
          }
          return item;
        });
        const updatedFormData: FormData = {
          ...updateFormData,
          form: updatedForm,
        };
        setUpdateFormData(updatedFormData);
      }

      //   const updatedForm = updateFormData.form.map((item: any) => {
      //     if (item.question === step) {
      //       const updatedFields = item.fields.map((field: any) => {
      //         if (field.type === type) {
      //           return {
      //             ...field,
      //             [keyName]: value, // Update the specified field with the new value
      //           };
      //         }
      //         return field;
      //       });
      //       return {
      //         ...item,
      //         fields: updatedFields,
      //       };
      //     }
      //     return item;
      //   });
      //   const updatedFormData: FormData = {
      //     ...updateFormData,
      //     form: updatedForm,
      //   };
      //   setUpdateFormData(updatedFormData);
    }
  };

  const handleCloseForm = () => {
    setNewFormData({
      name: "",
      formType: "lead",
      list: "",
      description: "",
      form: [],
    });
  };

  const addOptions = (question: any) => {
    if (userType === "Create") {
      const newData = newFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "multiple_options" && j.options.length > 0) {
                const lastOption = j.options[j.options.length - 1];
                const seenValues = new Set();

                const checkVal = j.options.some((obj: any) => {
                  const lowercaseValue = obj.value.toLowerCase();
                  if (seenValues.has(lowercaseValue)) {
                    return true;
                  }
                  seenValues.add(lowercaseValue);
                  return false;
                });

                if (
                  lastOption.displayName.trim() === "" ||
                  lastOption.value.trim() === ""
                ) {
                  toast.error("Please add option");
                  return j;
                } else if (checkVal && j.options.length > 1) {
                  toast.error("Please add Different Option");
                  return j;
                }
              }
              return {
                ...j,
                options: [
                  ...j.options,
                  {
                    displayName: `Option_${j.options.length + 1}`,
                    value: ``,
                    // value: `Option ${j.options.length + 1}`,
                  },
                ],
              };
            }),
          };
        }
        return i;
      });
      setNewFormData({ ...newFormData, form: newData });
    } else {
      const newData = updateFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "multiple_options" && j.options.length > 0) {
                const lastOption = j.options[j.options.length - 1];
                if (
                  lastOption.displayName.trim() === "" ||
                  lastOption.value.trim() === ""
                ) {
                  toast.error("Please add option");
                  return j;
                } else if (
                  j.options.every(
                    (item: any, index: number, array: any) =>
                      item.value.toLowerCase().trim() ===
                      array[0].value.toLowerCase().trim()
                  ) &&
                  j.options.length > 1
                ) {
                  toast.error("Please add Different Option");
                  return j;
                }
              }
              return {
                ...j,
                options: [
                  ...j.options,
                  {
                    displayName: `Option ${j.options.length + 1}`,
                    value: ``,
                    // value: `Option ${j.options.length + 1}`,
                  },
                ],
              };
            }),
          };
        }
        return i;
      });
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const updateOptions = (
    question: any,
    optionValue: number,
    value: string,
    keyValue: string
  ) => {
    if (userType == "Create") {
      const newData = newFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "multiple_options") {
                const newOptions = j.options.map(
                  (option: any, index: number) => {
                    if (index === optionValue) {
                      return {
                        ...option,
                        [keyValue]: value,
                      };
                    }
                    return option;
                  }
                );
                return {
                  ...j,
                  options: newOptions,
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setNewFormData({ ...newFormData, form: newData });
    } else {
      const newData = updateFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "multiple_options") {
                const newOptions = j.options.map(
                  (option: any, index: number) => {
                    if (index === optionValue) {
                      return {
                        ...option,
                        [keyValue]: value,
                      };
                    }
                    return option;
                  }
                );
                return {
                  ...j,
                  options: newOptions,
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const deleteOptions = (question: any, optionValue: number) => {
    const formDataToUpdate =
      userType === "Create" ? newFormData : updateFormData;

    const newData = formDataToUpdate.form.map((step: any) => {
      if (step.question === question) {
        return {
          ...step,
          fields: step.fields.map((field: any) => {
            if (field.type === "multiple_options") {
              const newOptions = field.options
                .filter((option: any, index: number) => index !== optionValue)
                .map((option: any, index: number) => {
                  return {
                    ...option,
                    displayName: `Option ${index + 1}`,
                  };
                });
              return {
                ...field,
                options: newOptions,
              };
            }
            return field;
          }),
        };
      }
      return step;
    });

    if (userType === "Create") {
      setNewFormData({ ...newFormData, form: newData });
    } else {
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const deleteUser = (id: string) => {
    const data = userList.filter((item: any) => item._id !== id);
    setUserList(data);
    setTotalUser(totalUser - 1);
    setOpenWithHeader(false);
  };

  const addNestedFieldToGroup = (question: string, fieldType: string) => {
    const fieldTemplates: any = {
      short_text: {
        fieldName: "Short text",
        displayName: "Short text",
        type: "short_text",
        placeholder: "Enter text",
        description: "",
        required: false,
      },
      email: {
        fieldName: "Email",
        displayName: "Email",
        type: "email",
        placeholder: "Enter email",
        description: "",
        required: false,
      },
      phone: {
        fieldName: "Phone",
        displayName: "Phone",
        type: "phone",
        placeholder: "Enter phone",
        description: "",
        required: false,
      },
      number: {
        fieldName: "Number",
        displayName: "Number",
        type: "number",
        placeholder: "Enter number",
        description: "",
        required: false,
      },
      date: {
        fieldName: "Date",
        displayName: "Date",
        type: "date",
        placeholder: "Select date",
        description: "",
        required: false,
      },
    };

    const newField = fieldTemplates[fieldType];
    if (!newField) return;

    if (userType === "Create") {
      const newData = newFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: [...groupFields, { ...newField }],
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setNewFormData({ ...newFormData, form: newData });
    } else {
      const newData = updateFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: [...groupFields, { ...newField }],
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const deleteNestedField = (question: string, fieldIndex: number) => {
    if (userType === "Create") {
      const newData = newFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: groupFields.filter((_: any, idx: number) => idx !== fieldIndex),
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setNewFormData({ ...newFormData, form: newData });
    } else {
      const newData = updateFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: groupFields.filter((_: any, idx: number) => idx !== fieldIndex),
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const updateNestedField = (question: string, fieldIndex: number, property: string, value: any) => {
    if (userType === "Create") {
      const newData = newFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: groupFields.map((field: any, idx: number) =>
                    idx === fieldIndex ? { ...field, [property]: value } : field
                  ),
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setNewFormData({ ...newFormData, form: newData });
    } else {
      const newData = updateFormData.form.map((i: any) => {
        if (i.question === question) {
          return {
            ...i,
            fields: i.fields.map((j: any) => {
              if (j.type === "group_field") {
                const groupFields = j.groupFields || [];
                return {
                  ...j,
                  groupFields: groupFields.map((field: any, idx: number) =>
                    idx === fieldIndex ? { ...field, [property]: value } : field
                  ),
                };
              }
              return j;
            }),
          };
        }
        return i;
      });
      setUpdateFormData({ ...updateFormData, form: newData });
    }
  };

  const deleteField = () => {
    const step = activeQuestion;
    if (userType == "Create") {
      let updatedForm = newFormData.form.filter(
        (item: any) => item.question !== step
      );
      updatedForm = updatedForm.map((item: any, index: number) => {
        const newQuestionNumber = `question_${index + 1}`;
        return { ...item, question: newQuestionNumber };
      });
      setNewFormData({ ...newFormData, form: updatedForm });
    } else {
      let updatedForm = updateFormData.form.filter(
        (item: any) => item.question !== step
      );
      updatedForm = updatedForm.map((item: any, index: number) => {
        const newQuestionNumber = `question_${index + 1}`;
        return { ...item, question: newQuestionNumber };
      });
      setUpdateFormData({ ...updateFormData, form: updatedForm });
    }
    setFieldModal(false);
  };

  const addCondition = (i: any) => {
    const formData = userType === "Create" ? newFormData : updateFormData;
    const updatedForm = formData.form.map((item: any) =>
      item.question === i.question
        ? {
            ...item,
            conditionRule: item.conditionRule
              ? [
                  ...item.conditionRule,
                  {
                    if: "is",
                    value:
                      item.fields[0]?.type === "multiple_options"
                        ? item.fields[0]?.options[0]?.value
                        : "",
                    then_go_to: "question_1",
                  },
                ]
              : [
                  {
                    if: "is",
                    value:
                      item.fields[0]?.type === "multiple_options"
                        ? item.fields[0]?.options[0]?.value
                        : "",
                    then_go_to: "question_1",
                  },
                ],
          }
        : item
    );

    userType === "Create"
      ? setNewFormData({ ...newFormData, form: updatedForm })
      : setUpdateFormData({ ...updateFormData, form: updatedForm });
  };

  const updateCondition = (
    i: any,
    key: string,
    value: string,
    indexValue: number
  ) => {
    if (userType == "Create") {
      const updatedForm = newFormData.form.map((item: any) => {
        if (item.question === i.question) {
          const updatedFields = item.conditionRule.map(
            (field: any, index: number) => {
              if (index === indexValue) {
                return {
                  ...field,
                  [key]: value, // Update the specified field with the new value
                };
              }
              return field;
            }
          );
          return {
            ...item,
            conditionRule: updatedFields,
          };
        }
        return item;
      });
      setNewFormData({ ...newFormData, form: updatedForm });
    } else {
      const updatedForm = updateFormData.form.map((item: any) => {
        if (item.question === i.question) {
          const updatedFields = item.conditionRule.map(
            (field: any, index: number) => {
              if (index === indexValue) {
                return {
                  ...field,
                  [key]: value, // Update the specified field with the new value
                };
              }
              return field;
            }
          );
          return {
            ...item,
            conditionRule: updatedFields,
          };
        }
        return item;
      });
      setUpdateFormData({ ...updateFormData, form: updatedForm });
    }
  };

  const handleDeleteCondition = (question: string, index: number) => {
    if (userType == "Create") {
      const updatedForm = newFormData.form.map((formItem: any) => {
        if (formItem.question === question) {
          // Check if the conditionRule exists and has the specified index
          if (formItem.conditionRule && formItem.conditionRule.length > index) {
            // Create a new conditionRule array without the specified index
            formItem.conditionRule.splice(index, 1);
          }
        }
        return formItem;
      });
      setNewFormData({ ...newFormData, form: updatedForm });
    } else {
      const updatedForm = updateFormData.form.map((formItem: any) => {
        if (formItem.question === question) {
          if (formItem.conditionRule && formItem.conditionRule.length > index) {
            // Create a new conditionRule array without the specified index
            formItem.conditionRule.splice(index, 1);
          }
        }
        return formItem;
      });
      setUpdateFormData({ ...updateFormData, form: updatedForm });
    }
  };

  const handleFieldNameChange = (question: string, newFieldName: string) => {
    if (userType == "Create") {
      const updatedForm = newFormData.form.map((item: any) => {
        if (item.question === question) {
          return {
            ...item,
            fields: item.fields.map((field: any) => ({
              ...field,
              fieldName: newFieldName
            }))
          };
        }
        return item;
      });
      setNewFormData({ ...newFormData, form: updatedForm });
    } else {
      const updatedForm = updateFormData.form.map((item: any) => {
        if (item.question === question) {
          return {
            ...item,
            fields: item.fields.map((field: any) => ({
              ...field,
              fieldName: newFieldName
            }))
          };
        }
        return item;
      });
      setUpdateFormData({ ...updateFormData, form: updatedForm });
    }
  };

  const getformLeadList = async () => {
    try {
      const id = "";
      const resp = await formLeadList(id);
      if (resp.data.statusCode == 200) {
        let array = resp.data.data;
        let newObject = {
          name: "Default lead list",
          _id: "",
        };
        array.unshift(newObject);

        setLeadList(array);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    handleFormList();
    getformLeadList();
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserName(userData.firstName);
    }
  }, []);

  const extractNumber = (val: string) => {
    const newVal = val.split("_");
    return newVal[1];
  };

  return (
    <Root id="main" className="main userform-page">
      <Header />
      <Spin size="large" tip="Loading..." spinning={isPageLoad}>
        {showFullPageForm ? (
          // Full page view of selected form with responses
          <div className="full-page-form-view">
            <button
              className="back-to-forms-button"
              onClick={() => {
                setShowFullPageForm(false);
                setUpdateFormData(initialFormData);
              }}
            >
              ← Back to Forms
            </button>
            <UserForm
              formDetail={updateFormData}
              onhandleEdit={() => {
                setFullScreenForm(true);
                setUserType("Update");
              }}
              handleActiveForm={(data) => {}}
              handleFormDelete={(id) => {
                deleteUser(id);
                setShowFullPageForm(false);
              }}
              useNewResponsesList={true}
            />
          </div>
        ) : (
          <>
          <section className="userform-section-1">
            <label>
              User Forms ({totalUser})
            </label>
            <div className="userform-section-1-actions">
              <button
                className="btn fw-bold auto_btn"
                type="button"
                onClick={() => onCreateNew ? onCreateNew() : onCreateNewForm()}
              >
                <i className="bi bi-plus-lg"></i>
                New Form
              </button>
            </div>
          </section>
        
          <section className="userform-section-2">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Form Name</th>
                  <th>Last Response</th>
                  <th>Responses</th>
                  <th>List Name</th>
                  <th>Created By</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((item: any, index: number) => {
                    return (
                      <tr 
                        key={index}
                        onClick={(e: React.MouseEvent<HTMLTableRowElement>) => {
                          const target = e.target as HTMLElement;
                          if (target.closest('.action-buttons') || target.closest('.status-toggle')) {
                            return;
                          }
                          onEditForm ? onEditForm(item._id) : handleClickUser(item._id);
                        }}
                        className="clickable-row"
                      >
                        <td>
                          <div className="name-cell">
                            <div className="primary text-truncate" title={item.name}>
                              {item.name}
                            </div>
                            <div className="secondary text-truncate" title={item.description}>
                              {item.description || 'No description'}
                            </div>
                          </div>
                        </td>
                        <td>
                          {item.lastResponseLeadName === null
                            ? "No response"
                            : item.lastResponseLeadName.length === 0
                            ? "No name"
                            : item.lastResponseLeadName}
                        </td>
                        <td className="number-cell">{item.totalResponse || 0}</td>
                        <td>{item.listName || "Default Lead List"}</td>
                        <td>{item.createdBy}</td>
                        <td>{moment(item.createdAt).format("DD MMM, YYYY")}</td>
                        <td>
                          <span 
                            className={`status-badge ${
                              item.status === "published" ? "status-published" : "status-draft"
                            }`}
                          >
                            {item.status === "published" ? "Published" : "Draft"}
                          </span>
                        </td>
                        <td>
                          <div className="action-buttons" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <button 
                              className="btn-action btn-edit"
                              onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                onEditForm ? onEditForm(item._id) : handleClickUser(item._id);
                              }}
                              title="Edit Form"
                            >
                              <img 
                                src="assets/img/edit2.png" 
                                alt="Edit" 
                                style={{ width: '16px', height: '16px' }}
                              />
                            </button>
                            <button 
                              className="btn-action btn-preview"
                              onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                window.open(`/form/${item.uniqueCode}`, '_blank');
                              }}
                              title="Preview Form"
                            >
                              <img 
                                src="assets/img/preview.png" 
                                alt="Preview" 
                                style={{ width: '16px', height: '16px' }}
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={8}>
                      <div className="empty-state">
                        <div className="empty-state-content">
                          <h3>No forms created yet</h3>
                          <p>Create your first form to start collecting responses</p>
                          <button
                            className="btn fw-bold auto_btn"
                            type="button"
                            onClick={() => onCreateNew ? onCreateNew() : onCreateNewForm()}
                          >
                            <i className="bi bi-plus-lg"></i>
                            Create First Form
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
        </>
        )}
      </Spin>
      <DrawerComponent
        openWithHeader={openWithHeader}
        setOpenWithHeader={setOpenWithHeader}
        drawerTitle="Form"
        size="full"
      >
        <UserForm
          formDetail={updateFormData}
          onhandleEdit={() => {
            setFullScreenForm(true);
            setUserType("Update");
          }}
          handleActiveForm={(data) => {}}
          handleFormDelete={(id) => {
            deleteUser(id);
          }}
          useNewResponsesList={true}
        />
      </DrawerComponent>
      {/* Popup for create new form */}
      <PopupComponent
        isOpen={formOpen}
        onClose={() => setFormCloseModel(true)}
        title="Create New Form"
        size="md"
        footer={
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              className="btn btn-secondary"
              onClick={() => {
                handleCloseForm();
                setFormOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn fw-bold auto_btn"
              onClick={() => {
                handleCreateForm();
              }}
            >
              Continue
            </button>
          </div>
        }
      >
        <div id="create_form">
          <div className="form-group">
            <Inputs
              name="test"
              type="text"
              autoComplete="off"
              className="form-control"
              placeholder={`Form name`}
              value={newFormData.name}
              onChange={(e: any) => updateCreateForm("name", e.target.value)}
              label="Form name"
              isRequired
              options='{item.type === "selection" && item.options}'
              id="testid"
            />
            <label htmlFor="lead-date" className="form-label mt-2">
              Save form responses to
            </label>
            <select
              className="form-control select_lead_list"
              value={newFormData.list}
              onChange={(e) => {
                updateCreateForm("list", e.target.value);
              }}
            >
              <option value="" disabled>
                Select list
              </option>
              {leadList.map((item: any, ixx: number) => {
                return (
                  <option value={item._id} key={ixx}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <Inputs
              name="test"
              type="text"
              autoComplete="off"
              className="form-control note_area"
              placeholder={`Description`}
              value={newFormData.description}
              onChange={(e: any) =>
                updateCreateForm("description", e.target.value)
              }
              label="Description"
              isRequired={false}
              options='{item.type === "selection" && item.options}'
              id="testid"
            />
          </div>
        </div>
      </PopupComponent>

      <DialogBox
        boxSize="full"
        openDialog={fullScreenForm}
        onClickCloseDialog={(e) => {
          setStepFormModel(true);
        }}
      >
        <Spin size="large" tip="Loading..." spinning={isPageLoad}>
          <div>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <h4
                  className="btn"
                  style={{ fontSize: "24px", padding: "0px" }}
                >
                  {userType == "Create"
                    ? newFormData.name
                    : updateFormData.name}
                </h4>
                {userType == "Create" ? (
                  <p>
                    Created by {userName} on{" "}
                    {moment(newFormData.createdAt).format("Do MMM YYYY")} at{" "}
                    {moment(newFormData.createdAt).format("hh:mm A")}
                  </p>
                ) : (
                  <p>
                    Created by {updateFormData.createdBy} on{" "}
                    {moment(updateFormData.createdAt).format("Do MMM YYYY")} at{" "}
                    {moment(updateFormData.createdAt).format("hh:mm A")}
                  </p>
                )}

                {/* <p>Created by Amit on 23 Nov 2023</p> */}
              </div>
              <div className="col-md-6 col-sm-12">
                <ul
                  className="nav mt-2 justify-content-end d-flex"
                  style={{ gap: "10px", padding: "10px" }}
                >
                  {/* {userType == "Create" ? (
                    ""
                  ) : (
                    <button className="ml-3 cursor btn btn-light border rounded">
                      <img
                        alt="img"
                        src="assets/img/preview.png"
                        title="Preview"
                        className="cursor-pointer "
                      />{" "}
                      Preview
                    </button>
                  )}
                  {userType == "Create" ? (
                    ""
                  ) : (
                    <button className="ml-3 cursor btn btn-light border rounded">
                      <img
                        alt="img"
                        src="assets/img/world.png"
                        title="Publish"
                        className="cursor-pointer "
                      />{" "}
                      Publish
                    </button>
                  )} */}
                </ul>
                {userType == "Create" ? (
                  ""
                ) : (
                  // <p className="justify-content-end d-flex mt-1 ">{newFormData.status == 'draft' ? 'In Draft' : `Published on  ${moment(newFormData.publishedLog?.publishedAt).format("Do MMM YYYY")} at ${moment(newFormData.publishedLog?.publishedAt).format("hh:mm A")}`} </p>
                  <p className="justify-content-end d-flex mt-1 ">
                    {newFormData.status == "draft"
                      ? "In Draft"
                      : `Published on  ${moment(
                          newFormData.publishedLog?.publishedAt
                        ).format("Do MMM YYYY")} at ${moment(
                          newFormData.publishedLog?.publishedAt
                        ).format("hh:mm A")}`}{" "}
                  </p>
                )}
              </div>
            </div>
            <h6
              className="text-dark mb-3"
              style={{ cursor: "pointer", width: "fit-content" }}
              onClick={() => {
                setQuestionBox(true);
              }}
            >
              Questions{" "}
              <span
                className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center text-white opacity-75"
                style={{ width: "22px", height: "22px", paddingBottom: "4px" }}
              >
                +
              </span>
            </h6>
            <Row>
              <Col md={4} sm={12}>
                <div className="content_box question_list">
                  {userType == "Create"
                    ? newFormData.form?.map((item: any, index: number) => {
                        return (
                          <button
                            key={index}
                            className={
                              activeField == item.question ? "active" : ""
                            }
                            onClick={() => {
                              setActiveField(item.question);
                            }}
                          >
                            <span>{index + 1}</span>
                            <p>
                              {item.fields[0].displayName}
                              {item.fields[0].required && " *"}
                            </p>
                          </button>
                        );
                      })
                    : updateFormData.form?.map((item: any, index: number) => {
                        return (
                          <button
                            key={index}
                            className={
                              activeField == item.question ? "active" : ""
                            }
                            onClick={() => {
                              setActiveField(item.question);
                            }}
                          >
                            <span>{index + 1}</span>
                            <p>
                              {item.fields[0].displayName}
                              {item.fields[0].required && " *"}
                            </p>
                          </button>
                        );
                      })}
                </div>
              </Col>
              <Col md={15} sm={12}>
                <div className="content_box d-flex">
                  {userType == "Create"
                    ? newFormData.form
                        ?.filter((item: any) => {
                          return item.question === activeField;
                        })
                        .map((i: any, ix: number) => {
                          return i.fields[0].type == "short_text" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "number" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Type your answer here"
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "phone" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />

                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Enter the field name"
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "email" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName.replace(
                                    /_/g,
                                    " "
                                  )}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="email"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Type your answer here"
                                // value={i.fields[0].fieldName}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "file_upload" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <div className="dragggable_file">
                                <span>
                                  <FontAwesomeIcon icon={faUpload} /> Choose
                                  file or drag file here{" "}
                                </span>
                                <input type="file" />
                              </div>
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "long_text" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                rows={5} // Specify the number of visible rows
                                cols={50} // Specify the number of visible columns
                                placeholder={i.fields[0].placeholder}
                                // value={i.fields[0].fieldName}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "date" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              {/* <input type="date" name="datePick" className='input_box' placeholder='check' value={i.fields[0].fieldName} onChange={(e) => { handleEditFormValue(i.question, i.fields[0].type, 'fieldName', e.target.value) }} /> */}
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Enter the field name"
                                // value={i.fields[0].fieldName}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "address" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                rows={4} // Specify the number of visible rows
                                cols={50} // Specify the number of visible columns
                                placeholder="Enter your multiline text here..."
                                value={i.fields[0].fieldName}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "fieldName",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "end_screen" ? (
                            <InputStyledComp key={ix}>
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder={"End screen"}
                                value={i.fields[0].description}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "multiple_options" ? (
                            <MultipleOption key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <div className="mt-3 multi_option_btn">
                                {i.fields[0].options.map(
                                  (j: any, jx: number) => {
                                    return (
                                      <div
                                        className="option_box_field"
                                        key={jx}
                                      >
                                        <span>{jx + 1}</span>
                                        <input
                                          type="text"
                                          placeholder="Enter Option"
                                          value={j.value.replace(/_/g, " ")}
                                          onChange={(e) => {
                                            updateOptions(
                                              i.question,
                                              jx,
                                              e.currentTarget.value,
                                              "value"
                                            );
                                          }}
                                        />
                                        <button
                                          className="delete_option"
                                          onClick={() => {
                                            deleteOptions(i.question, jx);
                                          }}
                                        >
                                          <Trash2 size={16} />
                                        </button>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                              <button
                                className="option_btn"
                                onClick={() => {
                                  addOptions(i.question);
                                }}
                              >
                                Add Option
                              </button>
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </MultipleOption>
                          ) : i.fields[0].type == "payment" ? (
                            <PaymentFiels key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="number"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                value={i.fields[0].amount}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "amount",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </PaymentFiels>
                          ) : i.fields[0].type == "text_display" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                className="discription"
                                placeholder="Description (optional)"
                                value={i.fields[0].description}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                className="input_box"
                                rows={6}
                                placeholder="Enter text content to display"
                                value={i.fields[0].textContent}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "textContent",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box mt-2"
                                placeholder="Button text (e.g., 'I Agree', 'Continue', 'Accept')"
                                value={i.fields[0].buttonText}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "buttonText",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "group_field" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Group Title (e.g., Bank Details)"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                className="discription"
                                placeholder="Group Description (optional)"
                                value={i.fields[0].description}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />

                              <div className="mt-3 p-3" style={{
                                border: '2px solid #e3f2fd',
                                borderRadius: '12px',
                                backgroundColor: '#fafafa'
                              }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h6 className="mb-0" style={{color: '#1976d2', fontWeight: 600}}>
                                    📋 Fields in this Group ({i.fields[0].groupFields?.length || 0})
                                  </h6>
                                  <button
                                    className="option_btn"
                                    onClick={() => {
                                      // Generate unique field name using parent field name
                                      const parentFieldName = i.fields[0].fieldName || 'group';
                                      const fieldIndex = (i.fields[0].groupFields?.length || 0) + 1;
                                      const newField = {
                                        fieldName: `${parentFieldName}_field_${fieldIndex}`,
                                        displayName: "",
                                        type: "short_text",
                                        placeholder: "Enter text",
                                        required: false
                                      };
                                      if (userType === "Create") {
                                        const newData = newFormData.form.map((formItem: any) => {
                                          if (formItem.question === i.question) {
                                            return {
                                              ...formItem,
                                              fields: formItem.fields.map((field: any) => {
                                                if (field.type === "group_field") {
                                                  return {
                                                    ...field,
                                                    groupFields: [...(field.groupFields || []), newField]
                                                  };
                                                }
                                                return field;
                                              })
                                            };
                                          }
                                          return formItem;
                                        });
                                        setNewFormData({ ...newFormData, form: newData });
                                      } else {
                                        const newData = updateFormData.form.map((formItem: any) => {
                                          if (formItem.question === i.question) {
                                            return {
                                              ...formItem,
                                              fields: formItem.fields.map((field: any) => {
                                                if (field.type === "group_field") {
                                                  return {
                                                    ...field,
                                                    groupFields: [...(field.groupFields || []), newField]
                                                  };
                                                }
                                                return field;
                                              })
                                            };
                                          }
                                          return formItem;
                                        });
                                        setUpdateFormData({ ...updateFormData, form: newData });
                                      }
                                    }}
                                  >
                                    + Add Field
                                  </button>
                                </div>

                                {i.fields[0].groupFields && i.fields[0].groupFields.length > 0 ? (
                                  <div>
                                    {i.fields[0].groupFields.map((field: any, fieldIdx: number) => (
                                      <Fragment key={fieldIdx}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            border: '1px solid #e0e0e0',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                            marginBottom: '10px'
                                          }}
                                        >
                                        <span
                                          style={{
                                            minWidth: '28px',
                                            height: '28px',
                                            backgroundColor: '#e3f2fd',
                                            color: '#1976d2',
                                            borderRadius: '50%',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            marginRight: '12px',
                                            flexShrink: 0
                                          }}
                                        >
                                          {fieldIdx + 1}
                                        </span>
                                        <div style={{ flex: 1, display: 'flex', gap: '10px', marginRight: '12px' }}>
                                          <input
                                            type="text"
                                            placeholder="Field Label (e.g., Full Name, Gender)"
                                            value={field.displayName}
                                            onChange={(e) => updateNestedField(i.question, fieldIdx, 'displayName', e.target.value)}
                                            style={{
                                              flex: 2,
                                              border: '1px solid #e0e0e0',
                                              borderRadius: '6px',
                                              padding: '10px 14px',
                                              fontSize: '14px',
                                              outline: 'none'
                                            }}
                                          />
                                          <select
                                            value={field.type}
                                            onChange={(e) => {
                                              const newType = e.target.value;
                                              // Update field type and add default properties for new types
                                              const updates: any = { type: newType };
                                              if (newType === 'multiple_options') {
                                                updates.multipleSelection = false;
                                                updates.options = [{ displayName: 'Option 1', value: 'option_1' }];
                                              }
                                              if (userType === "Create") {
                                                const newData = newFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, ...updates } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setNewFormData({ ...newFormData, form: newData });
                                              } else {
                                                const newData = updateFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, ...updates } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setUpdateFormData({ ...updateFormData, form: newData });
                                              }
                                            }}
                                            style={{
                                              flex: 1,
                                              border: '1px solid #e0e0e0',
                                              borderRadius: '6px',
                                              padding: '10px 14px',
                                              fontSize: '13px',
                                              outline: 'none',
                                              backgroundColor: '#fff',
                                              cursor: 'pointer'
                                            }}
                                          >
                                            <option value="short_text">Text</option>
                                            <option value="email">Email</option>
                                            <option value="phone">Phone</option>
                                            <option value="number">Number</option>
                                            <option value="date">Date</option>
                                            <option value="long_text">Long Text</option>
                                            <option value="multiple_options">Radio/Checkbox</option>
                                          </select>
                                        </div>
                                        <button
                                          className="delete_option"
                                          onClick={() => deleteNestedField(i.question, fieldIdx)}
                                          title="Delete field"
                                        >
                                          <Trash2 size={16} />
                                        </button>
                                      </div>

                                      {/* Options editor for radio/checkbox fields */}
                                      {field.type === 'multiple_options' && (
                                        <div style={{ marginTop: '12px', marginLeft: '40px' }}>
                                          <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <label style={{ fontSize: '13px', color: '#666' }}>
                                              <input
                                                type="checkbox"
                                                checked={field.multipleSelection || false}
                                                onChange={(e) => {
                                                  if (userType === "Create") {
                                                    const newData = newFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, multipleSelection: e.target.checked } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setNewFormData({ ...newFormData, form: newData });
                                                  } else {
                                                    const newData = updateFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, multipleSelection: e.target.checked } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setUpdateFormData({ ...updateFormData, form: newData });
                                                  }
                                                }}
                                                style={{ marginRight: '6px' }}
                                              />
                                              Allow multiple selections (checkboxes)
                                            </label>
                                          </div>
                                          {field.options?.map((option: any, optIdx: number) => (
                                            <div key={optIdx} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                              <span style={{ fontSize: '12px', color: '#999', minWidth: '20px' }}>{optIdx + 1}.</span>
                                              <input
                                                type="text"
                                                value={option.displayName}
                                                placeholder="Option label"
                                                onChange={(e) => {
                                                  const newOptions = [...field.options];
                                                  newOptions[optIdx] = {
                                                    ...option,
                                                    displayName: e.target.value,
                                                    value: e.target.value.toLowerCase().replace(/\s+/g, '_')
                                                  };
                                                  if (userType === "Create") {
                                                    const newData = newFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setNewFormData({ ...newFormData, form: newData });
                                                  } else {
                                                    const newData = updateFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setUpdateFormData({ ...updateFormData, form: newData });
                                                  }
                                                }}
                                                style={{
                                                  flex: 1,
                                                  border: '1px solid #e0e0e0',
                                                  borderRadius: '6px',
                                                  padding: '8px 12px',
                                                  fontSize: '13px',
                                                  outline: 'none'
                                                }}
                                              />
                                              {field.options.length > 1 && (
                                                <button
                                                  className="delete_option"
                                                  onClick={() => {
                                                    const newOptions = field.options.filter((_: any, idx: number) => idx !== optIdx);
                                                    if (userType === "Create") {
                                                      const newData = newFormData.form.map((formItem: any) => {
                                                        if (formItem.question === i.question) {
                                                          return {
                                                            ...formItem,
                                                            fields: formItem.fields.map((f: any) => {
                                                              if (f.type === "group_field") {
                                                                return {
                                                                  ...f,
                                                                  groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                    idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                  )
                                                                };
                                                              }
                                                              return f;
                                                            })
                                                          };
                                                        }
                                                        return formItem;
                                                      });
                                                      setNewFormData({ ...newFormData, form: newData });
                                                    } else {
                                                      const newData = updateFormData.form.map((formItem: any) => {
                                                        if (formItem.question === i.question) {
                                                          return {
                                                            ...formItem,
                                                            fields: formItem.fields.map((f: any) => {
                                                              if (f.type === "group_field") {
                                                                return {
                                                                  ...f,
                                                                  groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                    idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                  )
                                                                };
                                                              }
                                                              return f;
                                                            })
                                                          };
                                                        }
                                                        return formItem;
                                                      });
                                                      setUpdateFormData({ ...updateFormData, form: newData });
                                                    }
                                                  }}
                                                  title="Delete option"
                                                >
                                                  <Trash2 size={14} />
                                                </button>
                                              )}
                                            </div>
                                          ))}
                                          <button
                                            className="option_btn"
                                            onClick={() => {
                                              const newOptions = [
                                                ...field.options,
                                                {
                                                  displayName: `Option ${field.options.length + 1}`,
                                                  value: `option_${field.options.length + 1}`
                                                }
                                              ];
                                              if (userType === "Create") {
                                                const newData = newFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setNewFormData({ ...newFormData, form: newData });
                                              } else {
                                                const newData = updateFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setUpdateFormData({ ...updateFormData, form: newData });
                                              }
                                            }}
                                            style={{ marginTop: '4px' }}
                                          >
                                            + Add Option
                                          </button>
                                        </div>
                                      )}
                                      </Fragment>
                                    ))}
                                  </div>
                                ) : (
                                  <div
                                    className="text-center py-4"
                                    style={{
                                      backgroundColor: '#fff',
                                      borderRadius: '8px',
                                      border: '2px dashed #e0e0e0'
                                    }}
                                  >
                                    <p className="text-muted mb-0" style={{fontSize: '14px'}}>
                                      No fields added yet. Click <strong>"+ Add Field"</strong> to start.
                                    </p>
                                  </div>
                                )}
                              </div>

                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : (
                            <div className="content_box">
                              <h2>Please create a question to continue</h2>
                            </div>
                          );
                        })
                    : updateFormData.form
                        ?.filter((item: any) => {
                          return item.question === activeField;
                        })
                        .map((i: any, ix: number) => {
                          return i.fields[0].type == "short_text" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "number" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Type your answer here"
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "phone" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />

                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Enter the field name"
                                // value={i.fields[0].fieldName.replace(/_/g, " ")}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "email" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName.replace(
                                    /_/g,
                                    " "
                                  )}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="email"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Type your answer here"
                                // value={i.fields[0].fieldName}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "file_upload" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <div className="dragggable_file">
                                <span>
                                  <FontAwesomeIcon icon={faUpload} /> Choose
                                  file or drag file here{" "}
                                </span>
                                <input type="file" />
                              </div>
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "long_text" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                rows={5} // Specify the number of visible rows
                                cols={50} // Specify the number of visible columns
                                placeholder="Enter your multiline text here..."
                                value={i.fields[0].fieldName}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "fieldName",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "date" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              {/* <input type="date" name="datePick" className='input_box' placeholder='check' value={i.fields[0].fieldName} onChange={(e) => { handleEditFormValue(i.question, i.fields[0].type, 'fieldName', e.target.value) }} /> */}
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder="Enter the field name"
                                // value={i.fields[0].fieldName}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "fieldName",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "address" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                rows={4} // Specify the number of visible rows
                                cols={50} // Specify the number of visible columns
                                placeholder="Enter your multiline text here..."
                                value={i.fields[0].fieldName}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "fieldName",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "end_screen" ? (
                            <InputStyledComp key={ix}>
                              <input
                                type="text"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                // placeholder={"End screen"}
                                // value={i.fields[0].description}
                                // onChange={(e) => {
                                //   handleEditFormValue(
                                //     i.question,
                                //     i.fields[0].type,
                                //     "description",
                                //     e.target.value
                                //   );
                                // }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "multiple_options" ? (
                            <MultipleOption key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <div className="mt-3 multi_option_btn">
                                {i.fields[0].options.map(
                                  (j: any, jx: number) => {
                                    return (
                                      <div
                                        className="option_box_field"
                                        key={jx}
                                      >
                                        <span>{jx + 1}</span>
                                        <input
                                          type="text"
                                          placeholder="Enter Option"
                                          value={j.value.replace(/_/g, " ")}
                                          // className="input_box"
                                          onChange={(e) => {
                                            updateOptions(
                                              i.question,
                                              jx,
                                              e.currentTarget.value,
                                              "value"
                                            );
                                          }}
                                        />
                                        <button
                                          className="delete_option"
                                          onClick={() => {
                                            deleteOptions(i.question, jx);
                                          }}
                                        >
                                          <Trash2 size={16} />
                                        </button>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                              <button
                                className="option_btn"
                                onClick={() => {
                                  addOptions(i.question);
                                }}
                              >
                                Add Option
                              </button>
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </MultipleOption>
                          ) : i.fields[0].type == "payment" ? (
                            <PaymentFiels key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  value={i.fields[0].displayName}
                                  placeholder={"Display Name"}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                value={i.fields[0].description}
                                className="discription"
                                placeholder="Discription (optional)"
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="number"
                                className="input_box"
                                placeholder={i.fields[0].placeholder}
                                value={i.fields[0].amount}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "amount",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </PaymentFiels>
                          ) : i.fields[0].type == "text_display" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Display Name"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                className="discription"
                                placeholder="Description (optional)"
                                value={i.fields[0].description}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />
                              <textarea
                                className="input_box"
                                rows={6}
                                placeholder="Enter text content to display"
                                value={i.fields[0].textContent}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "textContent",
                                    e.target.value
                                  );
                                }}
                              />
                              <input
                                type="text"
                                className="input_box mt-2"
                                placeholder="Button text (e.g., 'I Agree', 'Continue', 'Accept')"
                                value={i.fields[0].buttonText}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "buttonText",
                                    e.target.value
                                  );
                                }}
                              />
                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : i.fields[0].type == "group_field" ? (
                            <InputStyledComp key={ix}>
                              <div className="field_name sr_number">
                                <span>
                                  {extractNumber(i.question)}{" "}
                                  <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                <input
                                  type="text"
                                  placeholder={"Group Title (e.g., Bank Details)"}
                                  value={i.fields[0].displayName}
                                  onChange={(e) => {
                                    handleEditFormValue(
                                      i.question,
                                      i.fields[0].type,
                                      "displayName",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <input
                                type="text"
                                className="discription"
                                placeholder="Group Description (optional)"
                                value={i.fields[0].description}
                                onChange={(e) => {
                                  handleEditFormValue(
                                    i.question,
                                    i.fields[0].type,
                                    "description",
                                    e.target.value
                                  );
                                }}
                              />

                              <div className="mt-3 p-3" style={{
                                border: '2px solid #e3f2fd',
                                borderRadius: '12px',
                                backgroundColor: '#fafafa'
                              }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h6 className="mb-0" style={{color: '#1976d2', fontWeight: 600}}>
                                    📋 Fields in this Group ({i.fields[0].groupFields?.length || 0})
                                  </h6>
                                  <button
                                    className="option_btn"
                                    onClick={() => {
                                      // Generate unique field name using parent field name
                                      const parentFieldName = i.fields[0].fieldName || 'group';
                                      const fieldIndex = (i.fields[0].groupFields?.length || 0) + 1;
                                      const newField = {
                                        fieldName: `${parentFieldName}_field_${fieldIndex}`,
                                        displayName: "",
                                        type: "short_text",
                                        placeholder: "Enter text",
                                        required: false
                                      };
                                      if (userType === "Create") {
                                        const newData = newFormData.form.map((formItem: any) => {
                                          if (formItem.question === i.question) {
                                            return {
                                              ...formItem,
                                              fields: formItem.fields.map((field: any) => {
                                                if (field.type === "group_field") {
                                                  return {
                                                    ...field,
                                                    groupFields: [...(field.groupFields || []), newField]
                                                  };
                                                }
                                                return field;
                                              })
                                            };
                                          }
                                          return formItem;
                                        });
                                        setNewFormData({ ...newFormData, form: newData });
                                      } else {
                                        const newData = updateFormData.form.map((formItem: any) => {
                                          if (formItem.question === i.question) {
                                            return {
                                              ...formItem,
                                              fields: formItem.fields.map((field: any) => {
                                                if (field.type === "group_field") {
                                                  return {
                                                    ...field,
                                                    groupFields: [...(field.groupFields || []), newField]
                                                  };
                                                }
                                                return field;
                                              })
                                            };
                                          }
                                          return formItem;
                                        });
                                        setUpdateFormData({ ...updateFormData, form: newData });
                                      }
                                    }}
                                  >
                                    + Add Field
                                  </button>
                                </div>

                                {i.fields[0].groupFields && i.fields[0].groupFields.length > 0 ? (
                                  <div>
                                    {i.fields[0].groupFields.map((field: any, fieldIdx: number) => (
                                      <Fragment key={fieldIdx}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            border: '1px solid #e0e0e0',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                            marginBottom: '10px'
                                          }}
                                        >
                                        <span
                                          style={{
                                            minWidth: '28px',
                                            height: '28px',
                                            backgroundColor: '#e3f2fd',
                                            color: '#1976d2',
                                            borderRadius: '50%',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            marginRight: '12px',
                                            flexShrink: 0
                                          }}
                                        >
                                          {fieldIdx + 1}
                                        </span>
                                        <div style={{ flex: 1, display: 'flex', gap: '10px', marginRight: '12px' }}>
                                          <input
                                            type="text"
                                            placeholder="Field Label (e.g., Full Name, Gender)"
                                            value={field.displayName}
                                            onChange={(e) => updateNestedField(i.question, fieldIdx, 'displayName', e.target.value)}
                                            style={{
                                              flex: 2,
                                              border: '1px solid #e0e0e0',
                                              borderRadius: '6px',
                                              padding: '10px 14px',
                                              fontSize: '14px',
                                              outline: 'none'
                                            }}
                                          />
                                          <select
                                            value={field.type}
                                            onChange={(e) => {
                                              const newType = e.target.value;
                                              // Update field type and add default properties for new types
                                              const updates: any = { type: newType };
                                              if (newType === 'multiple_options') {
                                                updates.multipleSelection = false;
                                                updates.options = [{ displayName: 'Option 1', value: 'option_1' }];
                                              }
                                              if (userType === "Create") {
                                                const newData = newFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, ...updates } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setNewFormData({ ...newFormData, form: newData });
                                              } else {
                                                const newData = updateFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, ...updates } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setUpdateFormData({ ...updateFormData, form: newData });
                                              }
                                            }}
                                            style={{
                                              flex: 1,
                                              border: '1px solid #e0e0e0',
                                              borderRadius: '6px',
                                              padding: '10px 14px',
                                              fontSize: '13px',
                                              outline: 'none',
                                              backgroundColor: '#fff',
                                              cursor: 'pointer'
                                            }}
                                          >
                                            <option value="short_text">Text</option>
                                            <option value="email">Email</option>
                                            <option value="phone">Phone</option>
                                            <option value="number">Number</option>
                                            <option value="date">Date</option>
                                            <option value="long_text">Long Text</option>
                                            <option value="multiple_options">Radio/Checkbox</option>
                                          </select>
                                        </div>
                                        <button
                                          className="delete_option"
                                          onClick={() => deleteNestedField(i.question, fieldIdx)}
                                          title="Delete field"
                                        >
                                          <Trash2 size={16} />
                                        </button>
                                      </div>

                                      {/* Options editor for radio/checkbox fields */}
                                      {field.type === 'multiple_options' && (
                                        <div style={{ marginTop: '12px', marginLeft: '40px' }}>
                                          <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <label style={{ fontSize: '13px', color: '#666' }}>
                                              <input
                                                type="checkbox"
                                                checked={field.multipleSelection || false}
                                                onChange={(e) => {
                                                  if (userType === "Create") {
                                                    const newData = newFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, multipleSelection: e.target.checked } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setNewFormData({ ...newFormData, form: newData });
                                                  } else {
                                                    const newData = updateFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, multipleSelection: e.target.checked } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setUpdateFormData({ ...updateFormData, form: newData });
                                                  }
                                                }}
                                                style={{ marginRight: '6px' }}
                                              />
                                              Allow multiple selections (checkboxes)
                                            </label>
                                          </div>
                                          {field.options?.map((option: any, optIdx: number) => (
                                            <div key={optIdx} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                              <span style={{ fontSize: '12px', color: '#999', minWidth: '20px' }}>{optIdx + 1}.</span>
                                              <input
                                                type="text"
                                                value={option.displayName}
                                                placeholder="Option label"
                                                onChange={(e) => {
                                                  const newOptions = [...field.options];
                                                  newOptions[optIdx] = {
                                                    ...option,
                                                    displayName: e.target.value,
                                                    value: e.target.value.toLowerCase().replace(/\s+/g, '_')
                                                  };
                                                  if (userType === "Create") {
                                                    const newData = newFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setNewFormData({ ...newFormData, form: newData });
                                                  } else {
                                                    const newData = updateFormData.form.map((formItem: any) => {
                                                      if (formItem.question === i.question) {
                                                        return {
                                                          ...formItem,
                                                          fields: formItem.fields.map((f: any) => {
                                                            if (f.type === "group_field") {
                                                              return {
                                                                ...f,
                                                                groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                  idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                )
                                                              };
                                                            }
                                                            return f;
                                                          })
                                                        };
                                                      }
                                                      return formItem;
                                                    });
                                                    setUpdateFormData({ ...updateFormData, form: newData });
                                                  }
                                                }}
                                                style={{
                                                  flex: 1,
                                                  border: '1px solid #e0e0e0',
                                                  borderRadius: '6px',
                                                  padding: '8px 12px',
                                                  fontSize: '13px',
                                                  outline: 'none'
                                                }}
                                              />
                                              {field.options.length > 1 && (
                                                <button
                                                  className="delete_option"
                                                  onClick={() => {
                                                    const newOptions = field.options.filter((_: any, idx: number) => idx !== optIdx);
                                                    if (userType === "Create") {
                                                      const newData = newFormData.form.map((formItem: any) => {
                                                        if (formItem.question === i.question) {
                                                          return {
                                                            ...formItem,
                                                            fields: formItem.fields.map((f: any) => {
                                                              if (f.type === "group_field") {
                                                                return {
                                                                  ...f,
                                                                  groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                    idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                  )
                                                                };
                                                              }
                                                              return f;
                                                            })
                                                          };
                                                        }
                                                        return formItem;
                                                      });
                                                      setNewFormData({ ...newFormData, form: newData });
                                                    } else {
                                                      const newData = updateFormData.form.map((formItem: any) => {
                                                        if (formItem.question === i.question) {
                                                          return {
                                                            ...formItem,
                                                            fields: formItem.fields.map((f: any) => {
                                                              if (f.type === "group_field") {
                                                                return {
                                                                  ...f,
                                                                  groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                                    idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                                  )
                                                                };
                                                              }
                                                              return f;
                                                            })
                                                          };
                                                        }
                                                        return formItem;
                                                      });
                                                      setUpdateFormData({ ...updateFormData, form: newData });
                                                    }
                                                  }}
                                                  title="Delete option"
                                                >
                                                  <Trash2 size={14} />
                                                </button>
                                              )}
                                            </div>
                                          ))}
                                          <button
                                            className="option_btn"
                                            onClick={() => {
                                              const newOptions = [
                                                ...field.options,
                                                {
                                                  displayName: `Option ${field.options.length + 1}`,
                                                  value: `option_${field.options.length + 1}`
                                                }
                                              ];
                                              if (userType === "Create") {
                                                const newData = newFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setNewFormData({ ...newFormData, form: newData });
                                              } else {
                                                const newData = updateFormData.form.map((formItem: any) => {
                                                  if (formItem.question === i.question) {
                                                    return {
                                                      ...formItem,
                                                      fields: formItem.fields.map((f: any) => {
                                                        if (f.type === "group_field") {
                                                          return {
                                                            ...f,
                                                            groupFields: f.groupFields.map((gf: any, idx: number) =>
                                                              idx === fieldIdx ? { ...gf, options: newOptions } : gf
                                                            )
                                                          };
                                                        }
                                                        return f;
                                                      })
                                                    };
                                                  }
                                                  return formItem;
                                                });
                                                setUpdateFormData({ ...updateFormData, form: newData });
                                              }
                                            }}
                                            style={{ marginTop: '4px' }}
                                          >
                                            + Add Option
                                          </button>
                                        </div>
                                      )}
                                      </Fragment>
                                    ))}
                                  </div>
                                ) : (
                                  <div
                                    className="text-center py-4"
                                    style={{
                                      backgroundColor: '#fff',
                                      borderRadius: '8px',
                                      border: '2px dashed #e0e0e0'
                                    }}
                                  >
                                    <p className="text-muted mb-0" style={{fontSize: '14px'}}>
                                      No fields added yet. Click <strong>"+ Add Field"</strong> to start.
                                    </p>
                                  </div>
                                )}
                              </div>

                              <button
                                className="delete_btn"
                                onClick={() => {
                                  setActiveQuestion(i.question);
                                  setFieldModal(true);
                                }}
                              >
                                <Trash2 size={16} />
                              </button>
                            </InputStyledComp>
                          ) : (
                            <div className="content_box">
                              <h2>Please create a question to continue</h2>
                            </div>
                          );
                        })}
                  {userType == "Create" && newFormData.form.length == 0 ? (
                    <>
                      <h2 className="m-auto">
                        Please create a question to continue{" "}
                        <h6
                          className="text-dark mb-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setQuestionBox(true);
                          }}
                        >
                          {" "}
                          Add Questions{" "}
                        </h6>
                      </h2>
                    </>
                  ) : userType == "Update" &&
                    updateFormData.form.length == 0 ? (
                    <>
                      <h2 className="m-auto">
                        Please create a question to continue{" "}
                        <h6
                          className="text-dark mb-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setQuestionBox(true);
                          }}
                        >
                          {" "}
                          Add Questions{" "}
                        </h6>
                      </h2>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
              <Col md={5} sm={12}>
                {/* end_screen */}
                <div className="content_box">
                  {updateFormData.form?.filter((item: any) => {
                    return item.question === activeField;
                  })[0]?.fields[0].type != "end_screen" ||
                  newFormData.form?.filter((item: any) => {
                    return item.question === activeField;
                  })[0]?.fields[0].type != "end_screen" ? (
                    <>
                      {newFormData.form.length > 0 ||
                      updateFormData.form.length > 0 == true ? (
                        <h4>Settings</h4>
                      ) : (
                        ""
                      )}

                      {userType == "Create"
                        ? newFormData.form
                            ?.filter((item: any) => {
                              return item.question === activeField;
                            })
                            .map((i: any, ix: number) => {
                              return (
                                <div
                                  className="d-flex justify-content-between mt-4"
                                  key={ix}
                                >
                                  <h6>Required</h6>
                                  <span onClick={() => {}}>
                                    <Toggle
                                      size="sm"
                                      checked={i.fields[0].required}
                                      onChange={(e: boolean) => {
                                        handleEditFormValue(
                                          i.question,
                                          i.fields[0].type,
                                          "required",
                                          !i.fields[0].required
                                        );
                                      }}
                                    />
                                  </span>
                                </div>
                              );
                            })
                        : updateFormData.form
                            ?.filter((item: any) => {
                              return item.question === activeField;
                            })
                            .map((i: any, ix: number) => {
                              return (
                                <div
                                  className="d-flex justify-content-between mt-4"
                                  key={ix}
                                >
                                  <p>Required</p>
                                  <span onClick={() => {}}>
                                    <Toggle
                                      size="sm"
                                      checked={i.fields[0].required}
                                      onChange={(e: boolean) => {
                                        handleEditFormValue(
                                          i.question,
                                          i.fields[0].type,
                                          "required",
                                          !i.fields[0].required
                                        );
                                      }}
                                    />
                                  </span>
                                </div>
                              );
                            })}

                      {/* Multiple selection  Multiple selection */}
                      {userType == "Create"
                        ? newFormData.form
                            ?.filter((item: any) => {
                              return (
                                item.question === activeField &&
                                item.fields[0].type == "multiple_options"
                              );
                            })
                            .map((i: any, ix: number) => {
                              return (
                                <div
                                  className="d-flex justify-content-between mt-4"
                                  key={ix}
                                >
                                  <h6>Multiple selection</h6>
                                  <span onClick={() => {}}>
                                    <Toggle
                                      size="sm"
                                      checked={i.fields[0].multipleSelection}
                                      onChange={(e: boolean) => {
                                        handleEditFormValue(
                                          i.question,
                                          i.fields[0].type,
                                          "multipleSelection",
                                          !i.fields[0].multipleSelection
                                        );
                                      }}
                                    />
                                  </span>
                                </div>
                              );
                            })
                        : updateFormData.form
                            ?.filter((item: any) => {
                              return (
                                item.question === activeField &&
                                item.fields[0].type == "multiple_options"
                              );
                            })
                            .map((i: any, ix: number) => {
                              return (
                                <div
                                  className="d-flex justify-content-between mt-4"
                                  key={ix}
                                >
                                  <p>Multiple selection</p>
                                  <span onClick={() => {}}>
                                    <Toggle
                                      size="sm"
                                      checked={i.fields[0].multipleSelection}
                                      onChange={(e: boolean) => {
                                        handleEditFormValue(
                                          i.question,
                                          i.fields[0].type,
                                          "multipleSelection",
                                          !i.fields[0].multipleSelection
                                        );
                                      }}
                                    />
                                  </span>
                                </div>
                              );
                            })}

                      {userType == "Create"
                        ? newFormData.form
                            ?.filter((item: any) => {
                              return item.question === activeField;
                            })
                            .map((i: any, ix: number) => {
                              if (i.fields[0].type != "file_upload") {
                                const leadFields = StoreData.user?.userPreferences?.customForm || [];
                                const currentFieldExists = leadFields.some((lf: any) => lf.value === i.fields[0].fieldName);

                                return (
                                  <div className="condition_box" key={ix}>
                                    {leadFields.length > 0 && (
                                      <div className="lead-field-mapping">
                                        <h6>Map to Lead Field</h6>
                                        <select
                                          className="lead-field-select"
                                          value={currentFieldExists ? i.fields[0].fieldName : ""}
                                          onChange={(e) => handleFieldNameChange(i.question, e.target.value)}
                                        >
                                          {!currentFieldExists && (
                                            <option value="">Select Lead Field (Optional)</option>
                                          )}
                                          {leadFields.map((leadField: any, idx: number) => (
                                            <option key={idx} value={leadField.value}>
                                              {leadField.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}

                                    <h6>Conditions</h6>
                                    <button onClick={() => addCondition(i)}>
                                      + Add condition
                                    </button>
                                    {i.conditionRule &&
                                      i.conditionRule.map(
                                        (item: any, index: number) => {
                                          if (i.fields[0].type == "date") {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.if}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "if",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <option value="is">
                                                      Is
                                                    </option>
                                                    <option value="is_not">
                                                      Is Not
                                                    </option>
                                                  </select>{" "}
                                                  Within last{" "}
                                                  <input
                                                    type="number"
                                                    placeholder="Enter Days"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  />{" "}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {newFormData.form.map(
                                                      (j: any, jx: number) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                            key={jx}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          } else if (
                                            i.fields[0].type ==
                                            "multiple_options"
                                          ) {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response is{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {i.fields[0].options.map(
                                                      (k: any, kx: number) => {
                                                        return (
                                                          <option
                                                            value={k.value}
                                                          >
                                                            {k.value}
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>
                                                  {/* <input type='text' value={item.value} onChange={(e)=>{updateCondition(i,'value',e.target.value,index)}}/> */}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {newFormData.form.map(
                                                      (j: any) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          } else {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.if}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "if",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <option value="is">
                                                      Contain
                                                    </option>
                                                    <option value="is_not">
                                                      Not Contain
                                                    </option>
                                                  </select>{" "}
                                                  <input
                                                    type="text"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  />{" "}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {newFormData.form.map(
                                                      (j: any) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          }
                                        }
                                      )}
                                  </div>
                                );
                              }
                            })
                        : updateFormData.form
                            ?.filter((item: any) => {
                              return item.question === activeField;
                            })
                            .map((i: any, ix: number) => {
                              if (i.fields[0].type != "file_upload") {
                                const leadFields = StoreData.user?.userPreferences?.customForm || [];
                                const currentFieldExists = leadFields.some((lf: any) => lf.value === i.fields[0].fieldName);

                                return (
                                  <div className="condition_box" key={ix}>
                                    {leadFields.length > 0 && (
                                      <div className="lead-field-mapping">
                                        <h6>Map to Lead Field</h6>
                                        <select
                                          className="lead-field-select"
                                          value={currentFieldExists ? i.fields[0].fieldName : ""}
                                          onChange={(e) => handleFieldNameChange(i.question, e.target.value)}
                                        >
                                          {!currentFieldExists && (
                                            <option value="">Select Lead Field (Optional)</option>
                                          )}
                                          {leadFields.map((leadField: any, idx: number) => (
                                            <option key={idx} value={leadField.value}>
                                              {leadField.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}

                                    <h6>Conditions</h6>
                                    <button onClick={() => addCondition(i)}>
                                      + Add condition
                                    </button>
                                    {i.conditionRule &&
                                      i.conditionRule.map(
                                        (item: any, index: number) => {
                                          if (i.fields[0].type == "date") {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.if}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "if",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <option value="is">
                                                      Is
                                                    </option>
                                                    <option value="is_not">
                                                      Is Not
                                                    </option>
                                                  </select>{" "}
                                                  Within last{" "}
                                                  <input
                                                    type="number"
                                                    placeholder="Enter Days"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  />{" "}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {updateFormData.form.map(
                                                      (j: any) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          } else if (
                                            i.fields[0].type ==
                                            "multiple_options"
                                          ) {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response is{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {/* <option value="none" selected disabled hidden>Select an Option</option>  */}
                                                    {i.fields[0].options.map(
                                                      (k: any, kx: number) => {
                                                        return (
                                                          <option
                                                            value={k.value}
                                                          >
                                                            {k.displayName}
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>
                                                  {/* <input type='text' value={item.value} onChange={(e)=>{updateCondition(i,'value',e.target.value,index)}}/> */}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {updateFormData.form.map(
                                                      (j: any) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          } else {
                                            return (
                                              <div className="condition-container">
                                                <div className="condition_title_bar">
                                                  {" "}
                                                  <h6>
                                                    Condition {index + 1}
                                                  </h6>{" "}
                                                  <button
                                                    onClick={() => {
                                                      handleDeleteCondition(
                                                        i.question,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    <img
                                                      className="delete-btn"
                                                      src="assets/img/delete.png"
                                                    />
                                                  </button>
                                                </div>
                                                <p className="conditions">
                                                  If Response{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.if}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "if",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <option value="is">
                                                      Contain
                                                    </option>
                                                    <option value="is_not">
                                                      Not Contain
                                                    </option>
                                                  </select>{" "}
                                                  <input
                                                    type="text"
                                                    value={item.value}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "value",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  />{" "}
                                                  Then Go to{" "}
                                                  <select
                                                    name="select_condition"
                                                    value={item.then_go_to}
                                                    onChange={(e) => {
                                                      updateCondition(
                                                        i,
                                                        "then_go_to",
                                                        e.target.value,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    {updateFormData.form.map(
                                                      (j: any) => {
                                                        return (
                                                          <option
                                                            value={j.question.replace(
                                                              "step",
                                                              "question"
                                                            )}
                                                          >
                                                            Question{" "}
                                                            {
                                                              j.question.split(
                                                                "_"
                                                              )[1]
                                                            }
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                  </select>{" "}
                                                </p>
                                              </div>
                                            );
                                          }
                                        }
                                      )}
                                  </div>
                                );
                              } else {
                              }
                            })}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '16px' }}>
              <button
                className="btn fw-bold auto_btn"
                onClick={() => {
                  handleSubmitForm();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </Spin>
      </DialogBox>
      <DialogBox
        boxSize="lg"
        openDialog={questionBox}
        onClickCloseDialog={(e) => setQuestionBox(e)}
      >
        <label htmlFor="lead-date" className="form-label col-md-6">
          <b>Select question type</b>
        </label>
        {/* <div className="d-flex flex-wrap"> */}
        <div className="question_box">
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("name");
            }}
          >
            <img src="assets/img/sortText.png" /> Name
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("short_text");
            }}
          >
            <img src="assets/img/sortText.png" /> Short text
          </button>

          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("email");
            }}
          >
            <img src="assets/img/darkMail.png" /> E-mail
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("phone");
            }}
          >
            <img src="assets/img/phone.png" /> Phone number
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("file_upload");
            }}
          >
            <img src="assets/img/file.png" /> File upload
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("long_text");
            }}
          >
            <img src="assets/img/text.png" /> Long Text
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("date");
            }}
          >
            <img src="assets/img/date.png" /> Date
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("number");
            }}
          >
            <img src="assets/img/number.png" /> Number
          </button>

          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("end_screen");
            }}
          >
            <img src="assets/img/endScreen.png" /> End screen
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("payment");
            }}
          >
            <img src="assets/img/dollar.png" /> Payment
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("address");
            }}
          >
            <img src="assets/img/location.png" />
            Address
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("multiple_options");
            }}
          >
            <img src="assets/img/check.png" /> Multiple options
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("text_display");
            }}
          >
            <img src="assets/img/text.png" /> Text Display
          </button>
          <button
            className="action_button col-2"
            onClick={() => {
              handleAddQuestion("group_field");
            }}
          >
            <img src="assets/img/sortText.png" /> Group Field
          </button>
        </div>
      </DialogBox>

      <DynamicConfirmationModal
        onConfirmation={() => deleteField()}
        showModal={fieldModal}
        toggleModal={() => {
          setFieldModal(false);
        }}
        title="Are you sure to want to Delete this Field"
      />

      <DynamicConfirmationModal
        onConfirmation={() => {
          handleCloseForm();
          setFormOpen(false);
          setFormCloseModel(false);
        }}
        showModal={formCloseModel}
        toggleModal={() => {
          setFormCloseModel(false);
        }}
        title="Are you sure to want to Close this Form"
      />

      <DynamicConfirmationModal
        onConfirmation={() => {
          handleCloseForm();
          setFullScreenForm(false);
          setStepFormModel(false);
        }}
        showModal={stepFormModel}
        toggleModal={() => {
          setStepFormModel(false);
        }}
        title="Are you sure to want to Close this Form"
      />

      <Toaster position="top-center" reverseOrder={false} />
    </Root>
  );
};

export default UserList;

const Root = styled.div`
  .full-page-form-view {
    padding: 20px;
    background: white;
    min-height: calc(100vh - 80px);
  }

  .back-to-forms-button {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    color: #374151;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 20px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: 'Gilroy-SemiBold', 'Gilroy', sans-serif;

    &:hover {
      background: #e5e7eb;
      border-color: #9ca3af;
      transform: translateX(-2px);
    }
  }

  .delete_btn {
    background: transparent;
    border: none;
    padding: 6px;
    cursor: pointer;
    color: #dc2626;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;

    &:hover {
      background: #fef2f2;
      color: #b91c1c;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .delete_option {
    background: transparent;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: #dc2626;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    margin-left: 8px;

    &:hover {
      background: #fef2f2;
      color: #b91c1c;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  @media (max-width: 500px) {
  }
  th,
  td {
    text-transform: capitalize;
  }
  @media screen and (max-width: 600px) {
    table thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    table tr {
      display: block;
      border: none;
      border-radius: 0px;
    }

    table td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: 0.8em;
      text-align: right;
      border-radius: 0px;
    }

    table td::before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
`;
